import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { ApiService } from '../../core/services/api.service';
import { ApiEnvelope } from '../models/content.models';
import type { ReminderCronHealth } from '../models/reminder-cron.models';

@Injectable({ providedIn: 'root' })
export class ReminderCronService {
  constructor(private readonly api: ApiService) {}

  getHealth() {
    return this.api
      .get<ApiEnvelope<ReminderCronHealth>>('platform/settings/reminder-cron/health')
      .pipe(map((response) => response.data));
  }

  setEnabled(enabled: boolean) {
    return this.api
      .patch<ApiEnvelope<ReminderCronHealth>>('platform/settings/reminder-cron/enabled', { enabled })
      .pipe(map((response) => response.data));
  }
}
